import { PdfViewerTool } from '../../PdfViewer.constants'

import { PdfViewerToolbarPanTool } from './PdfViewerToolbarPanTool'
import { PdfViewerToolbarSearchTool } from './PdfViewerToolbarSearchTool'
import { PdfViewerToolbarThumbnailsTool } from './PdfViewerToolbarThumbnailsTool'
import { PdfViewerToolbarViewControlsTool } from './PdfViewerToolbarViewControlsTool'
import { PdfViewerToolbarZoomTool } from './PdfViewerToolbarZoomTool'

export const PDF_VIEWER_TOOLBAR_TOOL_COMPONENT_BY_TOOL = {
  [PdfViewerTool.Pan]: PdfViewerToolbarPanTool,
  [PdfViewerTool.Search]: PdfViewerToolbarSearchTool,
  [PdfViewerTool.Thumbnails]: PdfViewerToolbarThumbnailsTool,
  [PdfViewerTool.ViewControls]: PdfViewerToolbarViewControlsTool,
  [PdfViewerTool.Zoom]: PdfViewerToolbarZoomTool,
}
